import {PNSLocationConfiguration} from './PNSLocation.configuration';

export {PNSLocationConfiguration};
